// extracted by mini-css-extract-plugin
export var bubble = "_u-0";
export var container = "_u-f";
export var contrastBorder = "_u-g";
export var greyOut = "_u-2";
export var initialsColor0 = "_u-3";
export var initialsColor1 = "_u-4";
export var initialsColor10 = "_u-d";
export var initialsColor11 = "_u-e";
export var initialsColor2 = "_u-5";
export var initialsColor3 = "_u-6";
export var initialsColor4 = "_u-7";
export var initialsColor5 = "_u-8";
export var initialsColor6 = "_u-9";
export var initialsColor7 = "_u-a";
export var initialsColor8 = "_u-b";
export var initialsColor9 = "_u-c";
export var initialsWrapper = "_u-1";
export var large = "_u-l";
export var medium = "_u-k";
export var mediumSmall = "_u-j";
export var mediumSmallMedium = "_u-o";
export var micro = "_u-h";
export var small = "_u-i";
export var tiny = "_u-n";
export var xTiny = "_u-m";